"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.emit = void 0;
const emitError = (e) => { throw e; };
const emitString = (s) => { throw new Error(s); };
const emit = (s) => s instanceof Error ? emitError(s) : emitString(s);
exports.emit = emit;
//# sourceMappingURL=emit.js.map